import { apiPath } from "../../constants";
import {
    axios,
    apiRequestOptions,
    errorRequestHandler,
    transformHttpResponse,
} from 'utils';
import {addSuccessMessage} from "../SnackBar";

export const RULE_CATEGORIES_POST_REQUEST = 'POST_RULE_CATEGORIES_REQUEST';
export const RULE_CATEGORIES_POST_FAILURE = 'POST_RULE_CATEGORIES_FAILURE';
export const RULE_CATEGORIES_POST_SUCCESS = 'POST_RULE_CATEGORIES_SUCCESS';

export const postRuleCategory = (data) => {
    return function(dispatch) {
        dispatch(postRuleCategoryRequest());
        return axios(apiRequestOptions(apiPath.RULE_CATEGORIES.POST, data))
            .then(transformHttpResponse)
            .then(response => {
                dispatch(addSuccessMessage('Category successfully added'));
                dispatch(postRuleCategorySuccess(response.data, data.rule.split("/").pop()))
            })
            .catch(error => transformHttpResponse(error.response))
            .catch(error => {
                dispatch(postRuleCategoryFailure(error));
                dispatch(errorRequestHandler(error));
            });
    }
};

const postRuleCategoryRequest = () => {
    return {
        type: RULE_CATEGORIES_POST_REQUEST,
    }
};

const postRuleCategoryFailure = (error) => {
    return {
        type: RULE_CATEGORIES_POST_FAILURE,
        error,
    }
};

const postRuleCategorySuccess = (ruleCategory, rule) => {
    return {
        type: RULE_CATEGORIES_POST_SUCCESS,
        ruleCategory,
        rule,
    }
};